import React from "react";
import { useSelector } from "react-redux";

import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Avatar from "@material-ui/core/Avatar";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

import LoadingSpinner from "../UI/LoadingSpinner/LoadingSpinner";

import Styles from "./TableRealized.module.css";

const useStyles = makeStyles((theme) => ({
	tableActions: {
		width: "100%",
	},
}));

const TableRealized = (props) => {
	const classes = useStyles();
	const history = useHistory();

	const isLoading = useSelector((state) => state.uiData.isLoading[9]);
	
	const iconButtonClickHandler = (item) => {
		const trainingType = item.trainingType.split(".")[2]

		history.push("/formacao/courses/completed/details/" + trainingType + "/" + item.id);
		
		// if (item.trainingType === "Enumerable.TrainingType.Program") {
		// 	history.push("/formacao/courses/completed/details/" + trainingType + "/" + item.id);
		// }
		// if (item.trainingType === "Enumerable.TrainingType.Class") {
		// 	history.push("/formacao/courses/completed/details/" + item.id + "/" + item.trainingType);
		// }
	};

	return (
		<div className={Styles["TableRealized"]}>
			<Table className={classes.table} aria-label="Actions table">
				<TableHead>
					<TableRow className={Styles["MuiTableRow-head"]}>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Nome</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Tipo</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Data inicio</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Data fim</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>
								Data realização
							</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Metodologia</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Estado</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Classificação</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Certificado</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}></div>
						</TableCell>
					</TableRow>
				</TableHead>
				{!isLoading && props.TableRealizedData.length > 0 && (
					<TableBody>
						{props.TableRealizedData.map((row) => (
							<TableRow
								key={row.name}
								className={Styles["MuiTableBody-root"]}
							>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
									component="th"
									scope="row"
								>
									<div className={Styles["subtitle"]}>
										{row.name}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div
										className={`${Styles["subtitle"]} ${Styles["former-avatar"]}`}
									>
										{row.trainingType ===
										"Enumerable.TrainingType.Program"
											? "Curso"
											: "Módulo"}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.shortStartDate}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.shortEndDate}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.shortCompletionDate}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.modality.name}
									</div>
								</TableCell>

								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{/* estados green (feito), yellow(em progresso), red (sem estado) */}
										{/* <div
										className={`${Styles["state"]} ${Styles["green"]}`}
									></div> */}
										{row.enrollmentStatus.nome}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.grade}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.isCertificateAvailable && (
											<Icon
												className={Styles["icon-done"]}
											>
												done
											</Icon>
										)}
										{row.isCertificateAvailable &&
											"Emitido"}
										{!row.isCertificateAvailable &&
											"Não Emitido"}
									</div>
								</TableCell>
								<TableCell
									className={`${Styles["MuiTableCell-root"]} ${Styles["MuiTableCell-icon"]}`}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										<IconButton
											aria-label="forward"
											onClick={iconButtonClickHandler.bind(
												null,
												row
											)}
										>
											<Icon>arrow_forward_ios</Icon>
										</IconButton>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				)}
			</Table>
			{isLoading && (
				<div style={{ textAlign: "center" }}>
					<LoadingSpinner />
				</div>
			)}
			{props.TableRealizedData.length == 0 && (
				<div className={Styles["no-record-found"]}>
					Não foi encontrado nenhum registo
				</div>
			)}
		</div>
	);
};

export default TableRealized;
